import { Action } from '@ngrx/store';
import { BaseFormConfig } from '../../models/base-form-config';
import { IWizardSpecification } from '../../../../../shared/modules/configurable-form/models/i-wizard-specification';
import { ADTSpecificationFormValues } from '../../models/adt-specification-form-values';
import { ADT_SPECIFICATION_FORM_CONFIG_NAMES } from '../../constants/form-config-names.enum';

export enum ADT_SPECIFICATION_ACTION_TYPES {
  RESET = '[ADT-Specification] Reset',
  LOAD_CONFIG = '[ADT-Specification] Load Config',
  LOAD_CONFIG_COMPLETE = '[ADT-Specification] Load Config Complete',
  SET_FORM_VALUES = '[ADT-Specification] Set form values',
  ADD_NEW_FORM = '[ADT-Specification] Add new form',
  DELETE_FORM = '[ADT-Specification] DELETE form',
  RESET_FORM_VALUES = '[ADT-Specification] Reset form values',
  SET_CAN_ADD_MULTIPLE_PRODUCTS = '[ADT-Specification] Set can add multiple products',
  LOAD_DATE_SELECTION = '[ADT-Specification] Load date selection',
  LOAD_MAIN_FORM_ID = '[ADT-Specification] Load main form id',
  RESET_DATE_SELECTION = '[ADT-Specification] Reset date selection',
  RESET_CONFIG = '[ADT-Specification] Reset config',
  UPDATE_FORM_IDS = '[ADT-Specification] Update form ids',
}

export class AdtSpecificationResetConfigAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.RESET_CONFIG;

  constructor() {}
}
export class AdtSpecificationUpdateFormIdsAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.UPDATE_FORM_IDS;

  constructor(public payload: any) {}
}

/**
 * Loads admixture order creation form config
 */
export class ADTSpecificationLoadConfigAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.LOAD_CONFIG;

  constructor(public payload: IWizardSpecification & { configName?: ADT_SPECIFICATION_FORM_CONFIG_NAMES }) {}
}

/**
 * Loads admixture order creation base config
 */
export class ADTSpecificationLoadConfigCompleteAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.LOAD_CONFIG_COMPLETE;

  constructor(public payload: BaseFormConfig) {}
}

/**
 * Set admixture order creation values
 */
export class ADTSpecificationSetFormValuesAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.SET_FORM_VALUES;

  constructor(public payload: ADTSpecificationFormValues[]) {}
}

/**
 * Loads new admixture order form product
 */
export class ADTSpecificationAddNewFormAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.ADD_NEW_FORM;

  constructor(public payload: any = null) {}
}

/**
 * Deletes admixture order form product
 */
export class ADTSpecificationDeleteFormAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.DELETE_FORM;

  constructor(public payload: number | string) {}
}

/**
 * Resets admixture order form values
 */
export class AdtSpecificationResetFormValuesAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.RESET_FORM_VALUES;

  constructor() {}
}

/**
 * Review wheter admixture order can add more products
 */
export class ADTSpecificationSetCanAddMultipleProductsAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.SET_CAN_ADD_MULTIPLE_PRODUCTS;

  constructor(public payload: boolean) {}
}

/**
 * Reset admixture order action state
 */
export class AdtSpecificationResetAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.RESET;

  constructor(payload?: any) {}
}

/**
 * Load main form id
 */
export class AdtLoadMainFormIdAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.LOAD_MAIN_FORM_ID;

  constructor(public payload: number) {}
}

/**
 * Load admixture order creation date selection
 */
export class ADTSpecificationLoadDateSelectionAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.LOAD_DATE_SELECTION;

  constructor(public payload: string) {}
}

export class ADTSpecificationResetDateSelectionAction implements Action {
  readonly type = ADT_SPECIFICATION_ACTION_TYPES.RESET_DATE_SELECTION;

  constructor() {}
}

export type AdtSpecificationActions =
  | ADTSpecificationLoadConfigAction
  | AdtSpecificationResetAction
  | ADTSpecificationLoadConfigCompleteAction
  | ADTSpecificationSetFormValuesAction
  | ADTSpecificationSetCanAddMultipleProductsAction
  | AdtSpecificationResetFormValuesAction
  | ADTSpecificationAddNewFormAction
  | ADTSpecificationDeleteFormAction
  | ADTSpecificationLoadDateSelectionAction
  | AdtLoadMainFormIdAction
  | AdtSpecificationResetConfigAction
  | ADTSpecificationResetDateSelectionAction;
